<template>
    <div>
        <Header :url='url'></Header>
        <div style="margin-top:1.1rem">
        <img src="/static/img/price/banner.jpg" alt="">
        <img @click="routerLink" src="/static/img/price/ying.jpg" alt="">
        <img @click="routerLink" src="/static/img/price/de.jpg" alt="">
        <img @click="routerLink" src="/static/img/price/fa.jpg" alt="">
        <img @click="routerLink" src="/static/img/price/xi.jpg" alt="">
        <img @click="routerLink" src="/static/img/price/yi.jpg" alt="">
        <img @click="routerLink" src="/static/img/price/ao.jpg" alt="">
        </div>
        <div class="bottom">
      <img src="/static/img/index/registered-bottom.jpg" alt />
    </div>
    </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  data () {
    return {
      url: '/price'
    }
  },
  created () {
    document.title = '欧洲VAT注册申报费用_英国VAT申报_德国VAT注册-麦德通服务价格'
    document.documentElement.scrollTop = 0
  },
  components: {Header},
  methods: {
    routerLink () {
      this.$router.push('/registered')
    }
  }
}
</script>

<style scoped>
img{
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/price.vue